import { Card, Chip, Select, FormControl, RadioGroup, FormControlLabel } from "@mui/material";
import { Formik, Field } from "formik";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Radio } from "react-loader-spinner";
import { MenuItem } from "react-pro-sidebar";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { GetSessionStorageData, nullUndefinedEmptyCheck, numberOnly } from "../../../../../Services/Helpers/Helper";
import { axiosInstance } from "../../../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../../../Utilities/Constants/ApiEndpoints";
import { I18_TRANSLATION_COMMON, MODES, API_RESPONSE, PROFESSIONAL_DETAILS, STORAGE_KEYS, NUMBER_CONSTANTS, VALIDATION_CONSTANT, ROUTES, TOASTER_CONFIGS } from "../../../../../Utilities/Constants/Constants";
import { REGISTRATION_ERRORS, ERROR_MESSAGES } from "../../../../../Utilities/Constants/Validations";
import * as yup from "yup";
import plus from "../../../../../../Assets/Registration/plus.svg";
import "./Expert.scss";


const Expert = (props:any)=> {
    const { t, i18n } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
    const [selectedSubjects, setSelectedSubjects]: any = useState([]);
    const [ courseSubject, setCourseSubject ]:any= useState(" ")
    const [modeOfTeching, setModeOfTeaching] = useState("");
    const [mode, setMode] = useState(MODES.EDIT);
    const [subjectList, setSubjectList]: any = useState([]);
    const [subjectListCopy, setSubjectListCopy]: any = useState([]);
    const [skillsList, setSkillsList]: any = useState([]);
    const [currentTag, setCurrentTag] = useState("");
    const [skillsTouched , setSkillsTouched] = useState<any>(API_RESPONSE.FALSE);
    const [ formSubmitted, setFormSubmitted ] =useState(API_RESPONSE.FALSE);
    const [ experience, setExperience] = useState('');
    const [ expSubject, setExpSubject ]:any= useState([]);
    const [ coursePayload, setCoursePayload]:any= useState([]);
    const [ personalDetail, setPersonalDetail ]:any = useState({});
    const [ courses, setCourses]:any = useState([]);
    const [ userType , setuserType]:any= useState("");
    const [ expectedFee , setExpectedFee ]= useState("");
    const [ minimumGradeYear, setMinimumGradeYear ]:any= useState("");
    const [ maximumGradeYear, setMaximumGradeYear ]:any= useState("");
    const [ gradeType, setGradeType ] = useState("grade");
    const [ courseFormSubmitted, setCourseFormSubmitted ] = useState(API_RESPONSE.FALSE);
    const [ curriculamList , setCurriculamList]:any = useState([]);
    const [ gradesList, setGradesList ]:any = useState([]);
    const [initialValues, setInitialValues] = useState({
      [PROFESSIONAL_DETAILS.DEGREE]: "",
      // [PROFESSIONAL_DETAILS.SUBJECT]: "",
      [PROFESSIONAL_DETAILS.CURRICULAM]: "",
      // [PROFESSIONAL_DETAILS.TEACHING_MODE]: '',
      // [PROFESSIONAL_DETAILS.EXPERIENCE]: "",
      [PROFESSIONAL_DETAILS.SKILLS]: "",
    });
    const location = useLocation();
    useEffect(()=>{
      setuserType(GetSessionStorageData(STORAGE_KEYS.ROLE));
     
     },[]);
    
    useEffect(() => {
      
      if(userType===`${NUMBER_CONSTANTS.FIVE}`){
        getCategoriesList(API_END_POINTS.GET_RECREATIONAL);
        getRegistrationDetail(API_END_POINTS.GET_CAMP_DETAILS);
        getCurriculamList();
      }else if(userType===`${NUMBER_CONSTANTS.NINE}`){
        getCategoriesList(API_END_POINTS.GET_RECREATIONAL);
        getRegistrationDetail(API_END_POINTS.GET_PERSONAL_DETAILS);
        getCurriculamList();
      }else if(userType===`${NUMBER_CONSTANTS.FOUR}`){
        getCategoriesList(API_END_POINTS.GET_CATEGORY_LIST);
        getRegistrationDetail(API_END_POINTS.GET_SPDETAILS);
        getCurriculamList();
        getGradesList();
      }
      
    }, [userType]);
  
     useEffect(()=>{
      if(personalDetail)
        setDetails();
     },[personalDetail]);
  
  
     const setDetails = ()=>{
      if(personalDetail.subject_and_experience?.length > NUMBER_CONSTANTS.ZERO){
        setInitialValues({
          [PROFESSIONAL_DETAILS.DEGREE]: personalDetail.degree,
        // [PROFESSIONAL_DETAILS.SUBJECT]: "",
        // [PROFESSIONAL_DETAILS.CURRICULAM]: personalDetail.curriculum,
        // [PROFESSIONAL_DETAILS.TEACHING_MODE]: personalDetail.teaching_mode,
        // [PROFESSIONAL_DETAILS.EXPERIENCE]: "",
        [PROFESSIONAL_DETAILS.SKILLS]: "",
        });
    
        setSkillsList(personalDetail.skills);
        // personalDetail.subject_and_experience? setExpSubject(personalDetail.subject_and_experience) : setExpSubject([]);
        personalDetail.subject_and_experience? setCoursePayload(personalDetail.subject_and_experience) : setCoursePayload([]);
        
      }
      // setModeOfTeaching(`${personalDetail.teaching_mode}`);
     
     };

     const getGradesList = ()=>{
        axiosInstance.get(API_END_POINTS.GET_GRADES_LIST).then(response=>{
          if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
            setGradesList(response.data.result.data)
          }
        })
     }
  
  
    /* Getting user detail */
     const getRegistrationDetail = (API_END_POINT:any)=>{
      axiosInstance.get(API_END_POINT).then((response)=>{
        if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
             setPersonalDetail(response.data.result.data[NUMBER_CONSTANTS.ZERO]);
        }
      })
    }
  
    /* Getting category list */
    const getCategoriesList = (API_POINT:any) => {
      axiosInstance.get(API_POINT).then((response: any) => {
        if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
          setSubjectList(response.data.result.data);
          setSubjectListCopy(response.data.result.data);
        }
      });
    };

    /* Getting curriculam list */
    const getCurriculamList = ()=>{
      axiosInstance.get(API_END_POINTS.CURRICULAM_LIST).then((response:any)=>{
        if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
          setCurriculamList(response.data.result.data);
        }
      })
    }
  
  /* Yup validation schema */
    const formValidationSchema = yup.object({
      [PROFESSIONAL_DETAILS.DEGREE]: yup
        .string()
        .required(REGISTRATION_ERRORS.DEGREE),
      /* [PROFESSIONAL_DETAILS.CURRICULAM]: yup
        .string()
        .required(REGISTRATION_ERRORS.CURRICULUM), */
      /* [PROFESSIONAL_DETAILS.TEACHING_MODE]: yup
        .string()
        .required(REGISTRATION_ERRORS.MODE_OF_TEACHING), */
      [PROFESSIONAL_DETAILS.SKILLS]: yup
        .array()
        .of(yup.string())
    });
  
    
    /* Update subject state */
    const onSelectSubjects = (event: any) => {
       setSelectedSubjects(event.target.value);
    };
  
    /* Setting experience */
    const onChangeExperience = (event:any)=>{
       setExperience(event.target.value);
    };
  
    useEffect(()=>{   
    },[subjectList])
  
    useEffect(()=>{
        let keyArr:any=[];
        expSubject?.forEach((obj: any) => {
            keyArr.push(obj.subject);
        });
        setCourses(keyArr);
        userType===`${NUMBER_CONSTANTS.FOUR}`?
        setSubjectList(subjectListCopy.filter((item: any,index:any) => !keyArr.includes(item.course_category_name))) :
        setSubjectList(subjectListCopy.filter((item: any,index:any) => !keyArr.includes(item.category_name)))
        setExperience('');
        setSelectedSubjects('');
  
    },[expSubject,subjectListCopy])
    const [ subjectExperience , setSubjectExperience ]:any= useState();
    useEffect(()=>{
    setExperience("");
    setMinimumGradeYear("");
    setMaximumGradeYear("");
    setExpectedFee("");
    setCourseSubject(" ")
    setCourseFormSubmitted(API_RESPONSE.FALSE);
    setModeOfTeaching("");
    setSubjectPayload();
    },[coursePayload]);


    useEffect(()=>{
    },[subjectExperience])
    const setSubjectPayload = ()=>{
      var payload = coursePayload;
      let result = payload.reduce(function (r:any, a:any) {
          r[a.subject] = r[a.subject] || [];
          r[a.subject].push(a);
          return r;
      },Object.create(API_RESPONSE.NULL));
      setSubjectExperience(result)
    };
  
    /* Setting course payload */
    const onAddSubjects = ()=>{
      setCourseFormSubmitted(API_RESPONSE.TRUE);
      let isNum = /^\d+(\.\d+)?$/.test(expectedFee);
      if(experience && isNum && gradeType && minimumGradeYear && courseSubject.id){
        setCoursePayload([...coursePayload,{
          id:courseSubject.id,
          subject: courseSubject.course_category_name,
          experience:experience,
          expected_fee:expectedFee,
          min:minimumGradeYear,
          grade:minimumGradeYear,
          max:maximumGradeYear,
          type:gradeType,
          course_mode: modeOfTeching
    }]) 
      }else{
        if(!courseSubject?.trim("")){
          setCourseSubject(" ")
        }
      }


      //Old logic of removing subject
       /* setExpSubject([...expSubject, {      
          "id":selectedSubjects.id,
          "subject":userType===`${NUMBER_CONSTANTS.FOUR}` ? selectedSubjects.course_category_name : selectedSubjects.category_name,
          "experience":experience      
      }]); */
     
     
    };

    /* Edit Added Subject */
    const onEditSubject = (course:any)=>{
      let courseIndex=coursePayload.indexOf(course);
      let coursePay=coursePayload;
      coursePay[courseIndex].isEdit ?
      coursePay[courseIndex].isEdit===API_RESPONSE.TRUE ? coursePay[courseIndex].isEdit=API_RESPONSE.FALSE : coursePay[courseIndex].isEdit=API_RESPONSE.TRUE :
      coursePay[courseIndex].isEdit= API_RESPONSE.TRUE;
      setCoursePayload([...coursePay]);
  };

  /* Edit Expected fee */
  const onEditInput = (course:any,fee:any) => {
    let courseIndex=coursePayload.indexOf(course);
    let coursePay=coursePayload;
    coursePay[courseIndex].expected_fee= fee;
    setCoursePayload([...coursePay])
  };

  /* Delete particular subject from subject list*/
  const onDeleteSubject = (course:any) => {
    let courseIndex=coursePayload.indexOf(course);
    let coursePay=coursePayload;
    coursePay.splice(courseIndex,NUMBER_CONSTANTS.ONE);
    setCoursePayload([...coursePay])
  };  
  
  
    /* Deleting tag from taglist */
    const handleDelete = (i: any) => () => {
      setSkillsList(skillsList.filter((item: any) => item !== skillsList[i]));
    };
  
  
    /* Deleting subjects from list */
    const handleDeleteSubject = (index: any) => () => {
    //  setExpSubject(expSubject.filter((_:any, i:any) => i !== index));
      setCoursePayload(coursePayload.filter((_:any, i:any) => i !== index));
  
      
    };
  
    /* Handling enter keypress */
    const handleKeyPress = (event: any) => {
      if (
        event.key === VALIDATION_CONSTANT.KEY_TYPE &&
        nullUndefinedEmptyCheck(event.target.value.trim())
      ) {
        onAddTag();
      }
    };
  

    /* Managing Skills */
    const onAddTag = () => {
      if (
        nullUndefinedEmptyCheck(currentTag.trim()) &&
        skillsList.filter((item: any) => item === currentTag)?.length === NUMBER_CONSTANTS.ZERO
      ) {
        setSkillsList([...skillsList, currentTag]);
      } else {
        if (nullUndefinedEmptyCheck(currentTag.trim())) toast.error(ERROR_MESSAGES.SKILL_VALIDATION);
      }
      setCurrentTag("");
    };
  
    /* Setting current input value */
    const setInputValue = (e: any) => {
      /* if (
        REGEX.ENGLISH_INPUT_VALIDATION.test(e.target.value) &&
        !/[0-9.]/.test(e.key)
      ) { */
      setCurrentTag(e.target.value);
      // }
    };
    /* Submit API call */
    const onSubmitData = (payload: any) => {
      payload.skills= skillsList;
      payload.introduction_video="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4";
      if(skillsList?.length> NUMBER_CONSTANTS.ZERO){
        let END_POINT= location.pathname=== ROUTES.PROFILE ? API_END_POINTS.TUTOR_PROFILE_UPDATE : API_END_POINTS.EXPERTS_REGISTRATION;
        axiosInstance.put(END_POINT + `?${VALIDATION_CONSTANT.PAGE}=` + NUMBER_CONSTANTS.TWO,payload).then((response:any)=>{
              if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
                toast.success(response.data.message,TOASTER_CONFIGS);               
                if(location.pathname !==ROUTES.PROFILE){
                  onNavigate(NUMBER_CONSTANTS.THREE);
                  setSubjectExperience([]);
                  setCoursePayload([]);
                }
                  
              }
          })
      }else{
        toast.error(REGISTRATION_ERRORS.SKILLS);
      }
     
    };
  
    /* Navigate call */
    const onNavigate = (state: any) => {
        props.setActiveStatus(state);
    };
  

    return(
        <div className="row details-wrapper">
        <div className="col-md-12">
          <Card className="pd-card-wrapper">
            {userType===`${NUMBER_CONSTANTS.THREE}` && <Formik
              initialValues={initialValues}
              validationSchema={formValidationSchema}
              enableReinitialize={API_RESPONSE.TRUE}
              onSubmit={(values, actions) => {
                onSubmitData(values);
              }}
            >
              {(formik: any) => {
                return (
                  <div>
                    <div className="row row-wrap">
                      <div className="col-md-6">
                        <div className="form-items">
                          <label className="form-label">
                            {t("Educational Qualification")}
                          </label>
                          <Field
                            name={PROFESSIONAL_DETAILS.DEGREE}
                            className="email-input"
                            placeholder={t("Educational Qualification")}
                          />
                          <div className="errorMessage">
                            {formik.touched[PROFESSIONAL_DETAILS.DEGREE] &&
                              formik.errors[PROFESSIONAL_DETAILS.DEGREE] && (
                                <p>
                                  {t(
                                    `${
                                      formik.errors[PROFESSIONAL_DETAILS.DEGREE]
                                    }`
                                  )}
                                </p>
                              )}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                      <div className="form-items">
                          <label className="form-label">{t("Skills")}</label>
                          <Field
                            name={PROFESSIONAL_DETAILS.SKILLS}
                            className="email-input"
                            value={currentTag}
                            placeholder={t("Skills")}
                            onKeyPress={(event: any) => {
                              handleKeyPress(event);
                            }}
                            onBlur={() => {
                              setSkillsTouched(API_RESPONSE.TRUE);
                            }}
                            onChange={(e:any)=>{
                              setInputValue(e);                           
                          }}
                          />
                          <img
                            className="plus-image"
                            src={plus}
                          //   onClick={()=>{onAddTag;formik.setFieldValue(PROFESSIONAL_DETAILS.SKILLS,skillsList)}}
                            onClick={onAddTag}
                          />
                        </div>
                        <div className="errorMessage">
                          {((skillsList?.length === NUMBER_CONSTANTS.ZERO &&
                            skillsTouched===API_RESPONSE.TRUE) || (formSubmitted && skillsList?.length === NUMBER_CONSTANTS.ZERO)) && (
                              <p>
                                {t(
                                  `${REGISTRATION_ERRORS.SKILLS}`
                                )}
                              </p>
                            )}
                        </div>
                        <div className="skills-list">
                          {skillsList?.map((skill: any, index: any) => {
                            return (
                              <Chip
                                className="skill-chip"
                                label={skill}
                                variant="outlined"
                                onDelete={handleDelete(index)}
                              />
                            );
                          })}
                        </div>
                      
                      </div>
                      
                    </div>
  
                    <div className="row row-wrap">
                      
                    </div>
                  {location.pathname ===ROUTES.PROFILE ? 
                  <div className="bi-buttons-wrap">
                  <button
                    className="btn btn-next"
                    type="submit"
                    onClick={() => {
                      setFormSubmitted(API_RESPONSE.TRUE);
                            formik.handleSubmit();
                    }}
                  >
                    Update
                  </button>
                </div>
                  :                 
                  
                  <div className="bi-buttons-wrap">
                        <button
                          className="btn btn-back"
                          onClick={() => onNavigate(1)}
                        >
                          Back
                        </button>
                        <button
                          className="btn btn-next"
                          type="submit"
                          onClick={() => {
                            setFormSubmitted(API_RESPONSE.TRUE);
                                  formik.handleSubmit();
                          }}
                        >
                          Next
                        </button>
                      </div>
                  }
                      
                   
                  </div>
                );
              }}
            </Formik>}
  
  
          </Card>
        </div>
      </div>
    )
};

export default Expert;